import { ROLE_LABELS } from "../contexts/AuthContext";

const ROLE_STYLES = {
  owner: "bg-slate-900 text-white border-slate-900",
  ops: "bg-slate-100 text-slate-800 border-slate-300",
  lead_tech: "bg-amber-100 text-amber-900 border-amber-300",
  tech_assistant: "bg-sky-100 text-sky-900 border-sky-300",
};

export default function RoleBadge({ role, className = "" }) {
  const style =
    ROLE_STYLES[role] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${style} ${className}`}
    >
      {ROLE_LABELS[role] || role}
    </span>
  );
}
